import { render, staticRenderFns } from "./CoordinateInputTable.vue?vue&type=template&id=a83bfee6"
import script from "./CoordinateInputTable.vue?vue&type=script&lang=js"
export * from "./CoordinateInputTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports